import './index.css';
import { Menu, MenuItem } from '@szhsin/react-menu';

type DropdownAction = {
  text: string;
  icon?: JSX.Element;
  className?: string;
  onClick: () => void;
};

type DropdownProps = {
  menuButton: JSX.Element;
  actions: DropdownAction[];
};

const Dropdown = (props: DropdownProps) => {
  return (
    <Menu
      menuButton={props.menuButton}
      menuClassName='dropdown_background opacity-95 p-2 shadow-primary rounded-md min-w-[140px]'
      portal={true}
    >
      {props.actions.map((x) => (
        <MenuItem
          key={x.text}
          onClick={x.onClick}
          className={`cursor-pointer text-primary-1 flex items-center gap-2 ${x.className}`}
        >
          {x.icon ?? null}
          <span className='text-lg'>{x.text}</span>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default Dropdown;
